






























import Vue from 'vue';

export default Vue.extend({
  props: {
    // One of: 'small', 'x-small'
    size: {
      type: String,
      default: 'small'
    }
  },

  data() {
    return {
      open: false
    };
  },

  methods: {
    openDialog() {
      this.open = true;
    },

    closeDialog() {
      this.open = false;
    }
  }
});
